<template>
  <MetricCard
    apiEndpoint="/google-ads/impressions"
    metricName="IMPRESSIONS"
    :formatData="formatImpressions"
    srcName="Google Ads"
  />
</template>

<script setup>
import { formatNumber } from '@/utils/helperFunctions';
import MetricCard from '@/components/MetricCard.vue';

const formatImpressions = (data) => formatNumber(data.data);
</script>
